import { BffOverlay } from "product-test-types";

import { STRAPI_URL } from "../env";

export async function fetchOverlay(): Promise<BffOverlay> {
  try {
    const response = await fetch(`${STRAPI_URL}/bff-overlay`, {
      credentials: "include",
    });

    if (response.status >= 400) {
      throw new Error(`Fetch failed with status ${response.status}.`);
    }

    const json = (await response.json()) as BffOverlay;

    return json;
  } catch {
    return {
      projects: [],
    };
  }
}
